import { getJurisdictionBaseUrl } from '@libs/helpers';

export const {
  landingUrl,
  dashboardUrl,
  jurisdictionId: DEFAULT_JURISDICTION_ID,
  isGlobal: IS_GLOBAL_JURISDICTION,
} = getJurisdictionBaseUrl(process.env.ENVIRONMENT);
